import { render, staticRenderFns } from "./IpoResultTransfer.vue?vue&type=template&id=7e33b5ad&scoped=true"
import script from "./IpoResultTransfer.vue?vue&type=script&lang=js"
export * from "./IpoResultTransfer.vue?vue&type=script&lang=js"
import style0 from "./IpoResultTransfer.vue?vue&type=style&index=0&id=7e33b5ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e33b5ad",
  null
  
)

export default component.exports